export const firebaseConfig = {
    apiKey: "AIzaSyCM7GER-jBa8Y17GsWcWqgV2wx-Bk_1a5k",
    authDomain: "alerte-stoc.firebaseapp.com",
    projectId: "alerte-stoc",
    storageBucket: "alerte-stoc.appspot.com",
    messagingSenderId: "820870383401",
    appId: "1:820870383401:web:a36e3614a998777c1bd938"
}
